import { Children, ReactNode } from 'react';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import TableSkeleton from '../../Layout/TableSkeleton';
import TableDownload from './TableDownload';
import styles from './TableWrapper.module.scss';

export interface ITableHeaderOptions {
    hideTitle?: boolean;
    isCsvDownloadAvailable?: boolean;
    isXlsxDownloadAvailable?: boolean;
    handleExportButtonClick?: () => void;
    containerClassName?: string;
}

export interface ITableWrapperProps {
    children: JSX.Element;
    title?: string;
    isLoading: boolean;
    headerOptions?: ITableHeaderOptions;
    rightSide?: ReactNode;
    footer?: ReactNode;
    testId?: string;
    track: TrackingEvent;
}

const TableWrapper = (props: ITableWrapperProps) => {
    const [translations] = useLanguage();

    return (
        <div data-testid={props.testId} className={props.headerOptions?.containerClassName ?? styles.table_wrapper_full}>
            <div className={styles.table_wrapper_top}>
                <h3>{props.title}</h3>
                <div className={`${styles.table_wrapper_right_side}${props.isLoading ? ` ${styles.table_wrapper_controls_loading}` : ''}`}>
                    {props.headerOptions?.isCsvDownloadAvailable && (
                        <TableDownload
                            handleExportButtonClick={props.headerOptions.handleExportButtonClick!}
                            track={{ eventCategory: props.track.eventCategory, eventAction: `${props.track.eventAction}DownloadClicked` }}
                        />
                    )}
                    {props.rightSide}
                </div>
            </div>
            {props.isLoading ? <TableSkeleton /> : Children.only(props.children)}
            <div className={`${styles.table_wrapper_footer}${props.isLoading ? ` ${styles.table_wrapper_controls_loading}` : ''}`}>{props.footer}</div>
        </div>
    );
};

export default TableWrapper;
